<!---- Static Navbar start -->
<div class="header-bar">
  <div class="navbar navbar-custom">
  <a class="navbar-brand logomain mt-2" id="hidetxt"  ><img src="assets/images/logotxt.svg"
      height="33" class="logo ml-3 logotextClick"><img src="assets/images/logotxt.svg" width="150" class="logo1 sectpad logotextClick"></a>
  </div>
  <div class="col-12 text-center webview"> 
    <!-- <img src="assets/images/eva-icons.svg" class="signimg1 prescsimg" /> -->
  </div>
  </div>
  <!---- Static Navbar end -->
<main role="main" class="maincntq">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
         
        <div class="col-sm-12 p-0 mt-5">
          <h1 class="text-center ssnHeadTxt">It looks like a deposit is required<br>
            to sign up for this plan</h1>
          <div class="col-lg-4 col-md-6 m-auto">
            <span class="ssnTxt d-inline-block mt-3">In order to complete signing up for this plan, you
              are kindly being asked to post a deposit. To find out
              the deposit amount and for further details, please
              contact:
            </span>
            <div class="ssnenergyTxt text-center">
              <p class="fntbold mb-0 mt-2">{{selectedProduct.energy_provider}}</p>
              <p class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}}</p>
              <p class="fntbold clrblue"><a [href]="'tel:' + providerContact.customerDeposit_enquiry" style="cursor:pointer !important;">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}</a></p>
            </div>
            <span class="ssnTxt text-left d-inline-block">
              Please be sure to mention Honest Gorilla, your Account Number ({{accountNumber}}) and {{productName}} when you speak with a {{providerContact.provider_name}} representative.
            </span>
           
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button class="btn sectbtn mt-5" style="width:auto !important; padding-left:25px; font-size:18px; padding-right:25px;" (click)="gotoHome()">THANK YOU</button>
          </div>
        </div>
      </div>
      <div class="row-fluid mobileview mt-0 pt-4">
          <div class="d-flex h-100 row pr-0">
              <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                  <img style="width:100% !important;" src="assets/images/signimg.jpg" />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                  <div class="arrow_box mr-3" [@flyOut]="'in'">
                      <h1 class="questionMob text-left">It looks like a deposit is required
                          to sign up for this plan</h1>
                  </div>
              </div>
          </div>    
          <div class="col-sm-9 col-12 mt-4">
              <p class="semi-bold ssndeptxt mb-1 text-center">Deposit Required</p>
              <p class="ssnTxt">In order to complete signing up for this plan, you
                are kindly being asked to post a deposit. To find out
                the deposit amount and for further details, please
                contact:
              </p>
              <div class="ssnenergyTxt text-center">
                <p class="fntbold mb-0 mt-2">{{providerContact != undefined && providerContact.provider_name ? providerContact.provider_name :""}}</p>
                <p class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}}</p>
                <p class="fntbold clrblue"><a [href]="'tel:' + providerContact.customerDeposit_enquiry" style="cursor:pointer !important;">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}</a></p>
              </div>
              <p class="ssnTxt">
                Please be sure to mention Honest Gorilla, your Account Number ({{accountNumber}}) and {{productName}}
                when you speak with a {{providerContact != undefined && providerContact.provider_name?providerContact.provider_name:""}} representative.
              </p>
            </div>
            <div class="d-flex h-100 row pr-0 mt-4">
                
                <div class="col-sm-9 col-11 offset-col-1 px-0 m-auto">
                        <div class="col-12 px-0 mobileview">
                            <label class="custom-control custom-checkbox chkbox mb-2" for="callnowtopostDeposit">
                                <input type="checkbox" class="custom-control-input mgntp10" id="callnowtopostDeposit" value="Call now to post deposit" name="callnowtopostDeposit"
                                    [(ngModel)]="ssndepostList.value4" (click)="onChangeRole($event)" />
                                <label class="custom-control-label font16" for="callnowtopostDeposit">Call now to post deposit</label>
                            </label>
                            <label class="custom-control custom-checkbox chkbox mb-2" for="notInterested">
                                <input type="checkbox" class="custom-control-input mgntp10" id="notInterested" value="Not interested" name="notInterested"
                                    [(ngModel)]="ssndepostList.value5" (click)="onChangeRole($event)" />
                                <label class="custom-control-label font16" for="notInterested">Not interested</label>
                            </label>
                        </div>
                </div>
            </div> 
              
           
             
            <div  class="col-sm-9 col-9 ml-auto px-0" id ="addf_id">
                <div class="col-12 px-0"  style="width:100% !important; text-align: right;">
                    <div  class="mb-3 ash_box text-right" [@flyOutans]="'in'" *ngIf="isChecked">
                       <h1 class="inline-block ansMob text-right" *ngIf="isChecked && ansinSSncheck != 'Goodbye'" >Dialing <a [href]="'tel:' + ansinSSncheck" class="clrblue">{{ansinSSncheck}}</a></h1>
                       <h1 class="inline-block ansMob text-right" *ngIf="isChecked && ansinSSncheck == 'Goodbye'">{{ansinSSncheck}}</h1>
                    </div>
                </div>
            </div>

            <div  class="d-flex h-100 row pr-0 mt-3" *ngIf="isChecked && (ansinSSncheck == '1-855-780-5209') && timeTrue == true">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                    <img style="width:100% !important;" src="assets/images/signimg.jpg" />
                </div> 
                <div class="col-sm-9 col-9 px-0 my-auto">
                    <div  class="arrow_box mr-3" [@flyOutans]="'in'" *ngIf="isChecked && (ansinSSncheck == '1-855-780-5209')">
                        <h1  class="questionMob">You are moments away from ﬁnalizing your enrollment.  Thank you for using Honest Gorilla to shop for a new energy plan. We appreciate you!</h1>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-12 px-0" *ngIf="isChecked && (ansinSSncheck == '1-855-780-5209') && timeTrue == true">
            <label class="custom-control custom-checkbox chkbox mb-2 pr-0" for="thankyou">
                <input type="checkbox" class="custom-control-input mgntp10" id="thankyou" value="Thank you" name="thankyou"
                    [(ngModel)]="ssndepostList.value6" (click)="onChangeRole($event)" />
                <label class="custom-control-label font20" for="thankyou">Thank you</label>
            </label>
            </div>



            <div  class="col-sm-9 col-9 ml-auto mt-4 px-0" id ="secondAns_id">
                <div class="col-12"  style="width:100% !important; text-align: right;">
                    <div  class="mb-3 ash_box text-right" [@flyOutans]="'in'" *ngIf="ansinSSncheck1 == 'Goodbye'">
                        <h1  class="ansMob text-right">{{ansinSSncheck1}}</h1>
                    </div>
                </div>
            </div>
      </div>
    </div>
  </div>
</main>